import React, { useEffect, useState } from 'react'
import { superAxiosRequest } from 'axiosApi'
import asideModalStore from 'Stores/asideModalStore'
import swal from 'sweetalert'
import st from './DeferredDealsList.module.scss'
import PageHeader from 'components/UI/PageHeader/PageHeader'
import Pagination from 'components/UI/Pagination/Pagination'
import Loader from 'components/UI/Loader/Loader'
import useLocalization from 'hooks/useLocalization'
import AddEditDeferredDeal from '../Deals/DealsCard/AddEditDeferredDeal/AddEditDeferredDeal'
import RowDeal from './RowDeal/RowDeal'

const initPagination = {
  page: 1,
  limit: 10,
}

const DeferredDealsList = () => {
  const [deals, setDeals] = useState(null)
  const [loading, setLoading] = useState(false)
  const [pagination, setPagination] = useState(initPagination)

  const { translate } = useLocalization({
    section: 'groups',
    subsection: 'group_setting',
    dict: {
      skill_levels: 'Skill levels',
      entries: 'Entries ',
      add_skill_level: 'Add skill level',
      edit: 'Edit',
      name: 'Name',
      cancel: 'Cancel',
      save: 'Save',
      delete: 'Delete',
    },
  })

  const fetchDeals = () => {
    superAxiosRequest({
      method: 'get',
      link: 'integration/deferred_deals',
      crm: true,
      params: {
        offset: (pagination.page - 1) * pagination.limit,
        limit: pagination.limit,
      },
    }).then(({ data }) => {
      setDeals(data)
      setLoading(false)
    })
  }

  useEffect(() => {
    setLoading(true)
    fetchDeals()
  }, [pagination])

  const editDeferredDeal = (data) => {
    const { id, funnel, deal, created_at, deferred_until } = data

    const calculateDaysDifference = (deferredDateStr, createdAtStr) => {
      if (!deferredDateStr) return 30 // Значение по умолчанию

      try {
        const createdDate = createdAtStr ? new Date(createdAtStr) : new Date() // Если created_at нет, используем текущую дату

        const deferredDate = new Date(deferredDateStr)

        const diffTime = deferredDate.getTime() - createdDate.getTime()

        const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24))

        return diffDays > 0 ? diffDays : 0
      } catch (error) {
        console.error('Ошибка вычисления разницы дат:', error)
        return 30
      }
    }

    const daysDifference = deferred_until
      ? calculateDaysDifference(deferred_until, created_at)
      : 30

    const ms = {
      modalBodyComponent: () => <AddEditDeferredDeal />,
      button: 'Save',
      link: `integration/deferred_deals/${id}`,
      title: 'Отложить сделку',
      isResponsive: true,
      crm: true,
      is_put: true,
      onSubmitSuccess: (responseData) => {
        setDeals((prevState) => ({
          ...prevState,
          result: prevState.result.map((item) =>
            item.id === id
              ? { ...item, deferred_until: responseData.deferred_until }
              : item,
          ),
        }))
      },

      onBeforeSubmit: (data) => {
        const deferredDays = data?.deferred_until

        let deferredDate = null

        if (
          deferredDays !== null &&
          deferredDays !== undefined &&
          deferredDays !== ''
        ) {
          const today = new Date()

          const futureDate = new Date(today)
          futureDate.setDate(today.getDate() + Number(deferredDays))

          const year = futureDate.getFullYear()
          const month = String(futureDate.getMonth() + 1).padStart(2, '0')
          const day = String(futureDate.getDate()).padStart(2, '0')

          deferredDate = `${year}-${month}-${day}`
        }

        return {
          deal: deal.id,
          funnel: funnel.id,
          deferred_until: deferredDate,
        }
      },
      valid: {
        deferred_until: 'required',
      },
    }
    asideModalStore.activity(ms, {
      deal: id,
      funnel: funnel,
      deferred_until: daysDifference,
    })
  }

  const deleteDeal = (data) => {
    swal({
      title: 'Are you sure',
      text: 'Are you sure you want to delete the deferred deal?',
      icon: 'warning',
      buttons: ['No', 'Yes'],
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        const apiConf = {
          method: 'delete',
          link: `integration/deferred_deals/${data.id}`,
          crm: true,
        }
        superAxiosRequest(apiConf).then(() => {
          setDeals((prevState) => ({
            ...prevState,
            result: prevState.result.filter((el) => el?.id !== data?.id),
          }))
        })
      }
    })
  }

  const action = (action, e, items) => {
    const actions = new Map([
      ['edit', () => editDeferredDeal(items)],
      ['delete', () => deleteDeal(items)],
    ])
    return actions.get(action)?.()
  }

  return (
    <div>
      <div className={st.header}>
        <PageHeader title={'Отложенные сделки'}>
          {/*<HeaderAddButton*/}
          {/*  title={translate.add_skill_level}*/}
          {/*  onClick={addDeferredDeal}*/}
          {/*/>*/}
        </PageHeader>
      </div>
      {loading ? (
        <Loader />
      ) : !deals?.result?.length ? (
        <div className={st.emptyState}>
          <h3 className={st.emptyTitle}>Нет отложенных сделок</h3>
          <p className={st.emptyDescription}>
            Отложенные сделки появятся здесь, когда вы их добавите
          </p>
        </div>
      ) : (
        <div className={st.conteinerClient}>
          <div className={st.quantityClients}>
            {translate.entries}: {deals._meta?.count_items || 0}
          </div>
          <div>
            {deals.result.map((deal, index) => (
              <RowDeal
                key={deal.id}
                deal={deal}
                index={index}
                action={action}
                translate={translate}
              />
            ))}
          </div>
        </div>
      )}
      {deals?.result?.length > 0 && deals?._meta?.count_items > 10 && (
        <div className={st.pagination}>
          <Pagination
            limit={pagination.limit}
            count={deals._meta.count_items || 0}
            page={pagination.page}
            onChange={(page) => setPagination({ ...pagination, page })}
            onChangePerPage={(limit) => {
              setPagination({ page: 1, limit })
            }}
          />
        </div>
      )}
    </div>
  )
}

export default DeferredDealsList
